export type ProjectViewMode = 'kanban' | 'list';

const GLOBAL_VIEW_MODE_KEY = 'pm:projectView';

function normalizeUserId(userId: string | undefined | null): string | null {
  if (userId == null || userId === '') return null;
  return String(userId);
}

function viewModeStorageKey(userId: string): string {
  return `pm:projectView:${userId}`;
}

function parseViewMode(raw: string | null): ProjectViewMode | null {
  if (raw === 'list' || raw === 'kanban') return raw;
  return null;
}

export function getStoredProjectViewMode(userId: string | undefined): ProjectViewMode {
  try {
    const uid = normalizeUserId(userId);
    if (uid) {
      const userScoped = parseViewMode(localStorage.getItem(viewModeStorageKey(uid)));
      if (userScoped) return userScoped;
    }
    const global = parseViewMode(localStorage.getItem(GLOBAL_VIEW_MODE_KEY));
    if (global) return global;
  } catch {
    /* ignore quota / private mode */
  }
  return 'kanban';
}

export function setStoredProjectViewMode(userId: string | undefined, mode: ProjectViewMode): void {
  try {
    localStorage.setItem(GLOBAL_VIEW_MODE_KEY, mode);
    const uid = normalizeUserId(userId);
    if (uid) {
      localStorage.setItem(viewModeStorageKey(uid), mode);
    }
  } catch {
    /* ignore quota / private mode */
  }
}
